module.exports = __webpack_public_path__ + "static/img/1_2_3.148ee0d6.jpg";